import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { colors, typography } from '../../../styles';
import ButtonSet from '../../ButtonSet';

const styles = css`
  background-color: ${colors.white};
  padding: 60px 0;
  .HomePageHeroImage_wrapper {
    width: 100vw;
    position: relative;
    margin: 0 auto;
    max-width: 1600px;
  }
  .HomePageHeroImage_headlineWrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
    background-color: ${colors.brand2};
    padding: 45px;
  }
  .HomePageHeroImage_headlineLine1 {
    font-family: ${typography.Serif};
    font-size: 54px;
    font-style: italic;
    color: ${colors.white};
  }
  .HomePageHeroImage_headlineLine2 {
    font-family: ${typography.Serif};
    font-size: 54px;
    font-style: italic;
    color: ${colors.white};
  }
  .buttonSet__container.center {
    justify-content: flex-start !important;
  }
  .HomePageHeroImage_listWrapper {
    overflow: hidden;
    position: relative;
  }
  .HomePageHeroImage_list {
    list-style: none;
    padding: 0;
    display: inline-flex;
    height: 72.533333vw;
    min-height: 272px;
    margin: 0;
    overflow: hidden;
    position: relative;
    transition: transform 500ms ease;
    @media (min-width: 600px) {
      z-index: 1;
      padding-top: 58.055556vw;
      display: block;
      width: 100%;
      height: auto;
      overflow: visible;
      transform: none !important;
      transition: none;
    }
    @media (min-width: 1600px) {
      padding-top: 929px;
    }
  }
  .HomePageHeroImage_listItem {
    width: 100vw;
    height: 100%;
    background-color: ${colors.white};
    background-size: cover;
    background-position: center center;
    @media (min-width: 600px) {
      border: 4px solid ${colors.white};
      position: absolute;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem01 {
    @media (min-width: 600px) {
      width: 44.097222vw;
      height: 18.888889vw;
      left: 0;
      top: 0;
      border-left: 0;
    }
    @media (min-width: 1600px) {
      width: 705.55px;
      height: 302.22px;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem02 {
    @media (min-width: 600px) {
      width: 55.902778vw;
      height: 30.555556vw;
      left: 44.097222vw;
      top: 0;
      border-right: 0;
    }
    @media (min-width: 1600px) {
      width: 894.44px;
      height: 488.88px;
      left: 705.55px;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem03 {
    @media (min-width: 600px) {
      width: 44.097222vw;
      height: 18.888889vw;
      left: 0;
      top: 18.888889vw;
      border-left: 0;
    }
    @media (min-width: 1600px) {
      width: 705.55px;
      height: 302.22px;
      top: 302.22px;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem04 {
    @media (min-width: 600px) {
      width: 19.375vw;
      height: 20.277778vw;
      left: 0;
      top: 37.777778vw;
      border-left: 0;
    }
    @media (min-width: 1600px) {
      width: 310px;
      height: 324.44px;
      top: 604.44px;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem05 {
    @media (min-width: 600px) {
      width: 24.722222vw;
      height: 20.277778vw;
      left: 19.375vw;
      top: 37.777778vw;
    }
    @media (min-width: 1600px) {
      width: 395.55px;
      height: 324.44px;
      left: 310px;
      top: 604.44px;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem06 {
    @media (min-width: 600px) {
      width: 21.736111vw;
      height: 27.5vw;
      left: 44.097222vw;
      top: 30.555556vw;
    }
    @media (min-width: 1600px) {
      width: 347.77px;
      height: 440px;
      left: 705.55px;
      top: 488.88px;
    }
  }
  .HomePageHeroImage_listItem.HomePageHeroImage_listItem07 {
    @media (min-width: 600px) {
      width: 34.1666667vw;
      height: 27.5vw;
      left: 65.833333vw;
      top: 30.555556vw;
      border-right: 0;
    }
    @media (min-width: 1600px) {
      width: 546.66px;
      height: 440px;
      left: 1053.32px;
      top: 488.88px;
    }
  }
  .HomePageHeroImage_listmobileButtonsWrapper {
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100vw;
    @media (min-width: 600px) {
      display: none;
    }
  }
  .HomePageHeroImage_listmobileButton {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: 0;
    background: white;
    &:focus {
      outline: none;
    }
  }
  .HomePageHeroImage_listmobileButtonPrev {
    transform: rotateZ(180deg);
  }
  .HomePageHeroImage_listmobileButtonNext {
    transform: none;
  }
`;


class HomePageHeroImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collageVwOffset: 0,
      collageVwOffsetStr: 0,
    };
  }

  render() {
    const { collageVwOffsetStr } = this.state;
    const { content } = this.props;
    return (
      <div className={styles} id="PhotoCollage">
        <div className="HomePageHeroImage_wrapper">
          <div className="HomePageHeroImage_listWrapper">
            <div className="HomePageHeroImage_listmobileButtonsWrapper">
              <button
                className="HomePageHeroImage_listmobileButton HomePageHeroImage_listmobileButtonPrev"
                onClick={() => this.slideList('previous')}
              >
                <img src="/images/icon-arrow-right-blue.svg" alt="previous" />
              </button>
              <button
                className="HomePageHeroImage_listmobileButton HomePageHeroImage_listmobileButtonNext"
                onClick={() => this.slideList('next')}
              >
                <img src="/images/icon-arrow-right-blue.svg" alt="next" />
              </button>
            </div>
            <ul className="HomePageHeroImage_list" style={{ transform: `translateX(${collageVwOffsetStr})` }}>
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem01"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].images[0].contentUrl'), { width: 720, height: 720 })})` }}
              />
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem02"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].images[1].contentUrl'), { width: 900, height: 900 })})` }}
              />
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem03"
              >
                <div className="HomePageHeroImage_headlineWrapper">
                  <h2>
                    <span className="HomePageHeroImage_headlineLine1">{get(content, '[0].headline')} </span>
                    <span className="HomePageHeroImage_headlineLine2">{get(content, '[0].headline_line_2')}</span>
                  </h2>
                  <ButtonSet buttonSetParent={get(content, '[0]')} />
                </div>
              </li>
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem04"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].images[2].contentUrl'), { width: 620, height: 620 })})` }}
              />
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem05"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].images[3].contentUrl'), { width: 620, height: 620 })})` }}
              />
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem06"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].images[4].contentUrl'), { width: 620, height: 620 })})` }}
              />
              <li
                className="HomePageHeroImage_listItem HomePageHeroImage_listItem07"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].images[5].contentUrl'), { width: 620, height: 620 })})` }}
              />
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

HomePageHeroImage.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export const sectionName = 'Home Page Hero Image';

export default HomePageHeroImage;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/HomePageHeroImage6.section.js